import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import CartProvider from './contexts/CartContext';
import CurrencyProvider from './contexts/CurrencyContext';
import AuthProvider from './contexts/AuthContext';
import { BrowserRouter as Router } from 'react-router-dom';
import './stylesheets/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <CurrencyProvider>
      <CartProvider>
        <Router>
          <App />
        </Router>
      </CartProvider>
    </CurrencyProvider>
  </AuthProvider>
);